export default __webpack_public_path__ + "img/paid-invoice.061929b8.svg";